export default __webpack_public_path__ + "fonts/3b74274ca1cfa68e1dea2a8e99ddbffd.woff2";